var map = {
	"./Avatar.png": 445,
	"./Group.png": 446,
	"./Otp_Image.png": 242,
	"./Shiny_Trophy_Success.png": 361,
	"./access.svg": 346,
	"./acess.png": 447,
	"./alert.png": 448,
	"./amount.png": 449,
	"./ar-benefit.svg": 347,
	"./bell.png": 450,
	"./bitcoin.png": 451,
	"./bnb.png": 452,
	"./cardImgPerfil.png": 453,
	"./clover.svg": 454,
	"./community.svg": 348,
	"./communityEx.png": 455,
	"./comunity.png": 456,
	"./construction.png": 362,
	"./copy.png": 457,
	"./copy2.png": 458,
	"./createImg.png": 459,
	"./diamond-benefit.svg": 349,
	"./diamond.svg": 460,
	"./diamond_grid.svg": 461,
	"./discont.png": 462,
	"./discontBenefits.png": 463,
	"./discount-benefit.svg": 350,
	"./error-dark.svg": 464,
	"./error.svg": 465,
	"./error_500.svg": 244,
	"./eth.png": 466,
	"./exclusive.png": 467,
	"./eye.png": 468,
	"./faq.png": 469,
	"./faqImg.png": 470,
	"./forgot-password-v2-dark.svg": 471,
	"./forgot-password-v2.svg": 472,
	"./gift.png": 473,
	"./hamburger.png": 474,
	"./heart.svg": 475,
	"./history.png": 476,
	"./iconMMA.png": 477,
	"./invest.png": 478,
	"./invest.svg": 351,
	"./login-background.png": 479,
	"./login-v2-dark.svg": 480,
	"./login-v2.svg": 481,
	"./logo.png": 482,
	"./logoDark.png": 483,
	"./matic.png": 484,
	"./meet-and-greet-benefit.svg": 352,
	"./meetEgreet.png": 485,
	"./nft.png": 366,
	"./nft2.png": 363,
	"./nfts.png": 486,
	"./noUser.png": 487,
	"./nobenefistImage.png": 488,
	"./not-authorized-dark.svg": 489,
	"./not-authorized.svg": 490,
	"./notFound.svg": 491,
	"./others-benefit.svg": 353,
	"./painting_frame.png": 492,
	"./painting_frame.svg": 354,
	"./pix.png": 493,
	"./pricetag.svg": 494,
	"./prize-draw-benefit.svg": 355,
	"./reality.png": 495,
	"./register-v2-dark.svg": 496,
	"./register-v2.svg": 497,
	"./scan.png": 243,
	"./share.png": 498,
	"./shiny-key.png": 359,
	"./social-action-benefit.svg": 356,
	"./social.png": 499,
	"./sorteio.png": 500,
	"./tamplate.png": 501,
	"./tema1.png": 502,
	"./tema2.png": 503,
	"./ticket.svg": 504,
	"./tokenMock.svg": 505,
	"./upload.png": 506,
	"./uploadSingle.png": 507,
	"./user.png": 508,
	"./user1.png": 509,
	"./user2.png": 510,
	"./user3.png": 511,
	"./user4.png": 512,
	"./verified.svg": 513,
	"./wallpayImg.png": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 444;